export const INPUT_MANAGEMENT_ALLOCATE_MODEL_LIST = 'INPUT_MANAGEMENT_ALLOCATE_MODEL_LIST'
export const INPUT_MANAGEMENT_ALLOCATE_SEARCH = 'INPUT_MANAGEMENT_ALLOCATE_SEARCH'
export const INPUT_MANAGEMENT_ALLOCATE_PAGINATION = 'INPUT_MANAGEMENT_ALLOCATE_PAGINATION'
export const INPUT_MANAGEMENT_ALLOCATE_DROP_DOWN_SEARCH_TYPE = 'INPUT_MANAGEMENT_ALLOCATE_DROP_DOWN_SEARCH_TYPE'